// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_modules_customers_customers_module_ts":"b987913d02c91a13","src_app_modules_admin_admin_module_ts":"a15e6c75f05a340f","src_app_modules_system-logs_system-logs_module_ts":"72b0ea50b59bf70e","node_modules_xlsx_xlsx_mjs":"146c7c4d62f54422"}[chunkId] + ".js";
};